// Owner-confirmed common working-condition note, shown once per stock listing section.
export const STOCK_CONDITION_NOTE = "All listed items are in good working condition.";

// Conditions already covered by the common note — not repeated on individual cards.
const GENERIC = new Set([
  "",
  "used / open-box",
  "working condition",
  "working condition — genuine pre-owned asset",
]);

export function isGenericCondition(c) {
  return GENERIC.has((c || "").trim().toLowerCase());
}

// Returns an item-specific condition worth showing (open-box unused, ~1yr used AC), else "".
export function specificCondition(p) {
  const c = ((p && p.condition) || "").trim();
  return isGenericCondition(c) ? "" : c;
}

// True only for an explicitly brand-new condition ("new" / "brand new", any case,
// ordinary whitespace/hyphen variations). "as new", "like new", "sealed pack",
// "used / open-box" and blank are NOT treated as confirmed brand-new.
export function isBrandNew(p) {
  const n = ((p && p.condition) || "").trim().toLowerCase().replace(/[\s\-]+/g, " ").trim();
  return n === "new" || n === "brand new";
}
